import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { DeviceDetectionService } from '../../services/device-detection';
import { RouterLink } from "@angular/router";
import { NgOptimizedImage } from '@angular/common';
import { PricingPageUrl } from '../../../shared/enums/app.enums';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [TranslocoModule, RouterLink, NgOptimizedImage],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FooterComponent {
  private deviceDetectionService = inject(DeviceDetectionService)
  isMobileDevice = this.deviceDetectionService.isMobile
  openSection = signal<string | null>('aboutUs');
  pricingPageUrl = PricingPageUrl;
  environment = environment;

  toggleSection(section: string):void{
    if(this.isMobileDevice()){
      this.openSection.set(this.openSection() === section ? null : section);
    } 
    
  }
}
